export default __webpack_public_path__ + "static/media/1851.633ed64f.png";